<template>
  <div class="main-wrapper">
    <div>
      <!-- <layout-header2></layout-header2> -->
      <layout-header></layout-header>
      <breadcrumb40></breadcrumb40>
      <!-- Page Content -->
      <div class="content">
        <div class="container">
          <div class="row">
            <div class="col-md-5 col-lg-4 col-xl-3 theiaStickySidebar">
              <sidebar></sidebar>
            </div>

            <div class="col-md-7 col-lg-8 col-xl-9" v-if="showspinner">
              <loader></loader>
            </div>

            <div class="col-md-7 col-lg-8 col-xl-9" v-else>
              <div class="row" style="margin-top: -30px;">
                <div class="col-md-12" id="encounter_container">
                  <!-- <h3 class="mb-3">Patient Encounter on {{ currentDay }} , {{ todays_date }} </h3> -->
                  <div class="appointment-tab mt-2 ml-md-3">
                    <!-- Appointment Tab -->
                    <ul class="nav nav-tabs nav-tabs-solid nav-tabs-rounded">
                      <li class="nav-item mr-1">
                        <a class="nav-link active" href="#today-appointments" data-toggle="tab">Open<span
                            class="rounded-bracket">{{ count_open }}</span></a>
                      </li>
                      <li class="nav-item mr-1">
                        <a class="nav-link" href="#closed-appointments" data-toggle="tab">Closed<span
                            class="rounded-bracket">{{ count_closed }}</span></a>
                      </li>
                    </ul>
                    <!-- /Appointment Tab -->

                    <div class="tab-content ml-md-3">
                      <!-- Today Appointment Tab -->
                      <div class="tab-pane show active" id="today-appointments">
                        <div class="card card-table mb-0" style="border: none;">
                          <div class="card-body">
                            <div class="table-responsive">
                              <table class="table table-hover table-center mb-0">
                                <thead>
                                  <tr>
                                    <th style="background-color: #F8F8F8;" class="text-left">Patient Name</th>
                                    <th style="background-color: #F8F8F8;" class="text-left">Suburb</th>
                                    <!-- <th style="background-color: #F8F8F8;" class="text-left">Mobile No.</th> -->
                                    <th style="background-color: #F8F8F8;" class="text-left">Date</th>
                                    <th style="background-color: #F8F8F8;" class="text-left">Time</th>
                                    <th style="background-color: #F8F8F8;" class="text-left">Action</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr v-for="(item, $index) in open_appointments.slice(
                                    (open_current - 1) * open_paginate,
                                    open_current * open_paginate
                                  )" :key="item.id">
                                    <td>
                                      <h2 class="table-avatar">
                                        <router-link :to="{
                                          name:
                                            'update-patient-encounter-update',
                                          params: {
                                            patient_id: item.patient,
                                            appointment_id: item.appointment,
                                            encounter_id: item.name,
                                          },
                                        }">
                                          <a href="javascript:void(0);" class="avatar avatar-sm mr-2"
                                            @click="ClosedAppointment()"><img class="avatar-img rounded-circle"
                                              v-bind:src="item.image
                                                ? config.base_url_for_Image +
                                                item.image
                                                : loadImg(
                                                  'Patient Profile.svg'
                                                )
                                                " alt="User Image" /></a>
                                          <a href="javascript:void(0);" @click="ClosedAppointment()">{{
                                            item.patient_name
                                            }}</a>
                                        </router-link>
                                      </h2>
                                    </td>
                                    <td>{{ item.suburb ? item.suburb : "-" }}</td>
                                    <!-- <td>
                                      {{
                                        item.mobile_no ? item.mobile_no : "-"
                                      }}
                                    </td> -->
                                    <td>
                                      {{ convertDate(item.encounter_date) }}
                                      <!-- <span class="d-block text-info">{{
                                        convertTime(item.appointment_datetime)
                                      }}
                                      </span> -->
                                    </td>

                                    <td>
                                      {{ item.encounter_time ? item.encounter_time.split(':').slice(0, 2).join(':') :
                                      '-' }}
                                    </td>


                                    <td class="text-left">
                                      <div class="table-action">
                                        <a href="#" class="btn btn-sm bg-info-light" data-toggle="modal"
                                          data-target="#appt_details" @click="ClosedAppointment()">
                                          <router-link :to="{
                                            name: 'update-patient-encounter-update',
                                            params: {
                                              patient_id: item.patient,
                                              appointment_id:
                                                item.appointment,
                                              encounter_id: item.name,
                                            },
                                          }">
                                            <i class="far fa-eye"></i> View Encounter
                                          </router-link>
                                        </a>
                                      </div>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                              <h5 v-if="open_appointments.length === 0 && !showspinner
                              " class="No_data">
                                No Patient Encounters Found
                              </h5>
                            </div>
                            <!-- pagination start -->

                            <div id="pagination" v-if="open_appointments.length > 10">
                              <ul class="pagination justify-content-center">

                                <!-- "Previous" Button -->
                                <li class="page-item" :class="open_current === 1 ? 'disabled' : ''">
                                  <a href="#" class="page-link" aria-label="Previous"
                                    @click.prevent="updateOpenCurrent(open_current - 1)">
                                    Previous
                                  </a>
                                </li>
                                <!-- Pagination Links (Display 5 at a time) -->
                                <li v-for="page_index in open_paginate_total" :key="page_index.id" :class="[
                                  'page-item',
                                  open_current === page_index ? 'active' : ''
                                ]" v-if="page_index >= open_current - 2 && page_index <= open_current + 2">
                                  <a href="#" class="page-link" @click.prevent="updateOpenCurrent(page_index)">
                                    {{ page_index }}
                                  </a>
                                </li>
                                <!-- "Next" Button -->
                                <li class="page-item" :class="open_current === open_paginate_total ? 'disabled' : ''
                                  ">
                                  <a href="#" class="page-link" aria-label="Next"
                                    @click.prevent="updateOpenCurrent(open_current + 1)">
                                    Next
                                  </a>
                                </li>
                              </ul>
                            </div>

                            <!-- pagination end -->
                          </div>
                        </div>
                      </div>
                      <!-- /Today Appointment Tab -->

                      <!-- Closed Appointment Tab -->
                      <div class="tab-pane" id="closed-appointments">
                        <div class="card card-table mb-0" style="border: none;">
                          <div class="card-body">
                            <div class="table-responsive">
                              <table class="table table-hover table-center mb-0">
                                <thead>
                                  <tr>
                                    <th class="text-left" style="background-color: #F8F8F8;">Patient Name</th>
                                    <!-- <th class="text-left" style="background-color: #F8F8F8;">City</th> -->
                                    <th class="text-left" style="background-color: #F8F8F8;">Suburb</th>
                                    <!-- <th class="text-left" style="background-color: #F8F8F8;">Mobile No.</th> -->
                                    <th class="text-left" style="background-color: #F8F8F8;">Date</th>
                                    <th class="text-left" style="background-color: #F8F8F8;">Time</th>
                                    <th class="text-left" style="background-color: #F8F8F8;">Action</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr v-for="(item,
                                    $index) in closed_appointments" :key="item.id" v-show="setClosedPaginate($index)">
                                    <td>
                                      <h2 class="table-avatar">
                                       
                                          <a href="javascript:void(0);" class="avatar avatar-sm mr-2"
                                            @click="OpenAppointment(); handlePatientClick(item)"><img class="avatar-img rounded-circle"
                                              v-bind:src="item.image
                                                ? config.base_url_for_Image +
                                                item.image
                                                : loadImg(
                                                  'Patient Profile.svg'
                                                )
                                                " alt="User Image" /></a>
                                          <a href="javascript:void(0);" @click="OpenAppointment(); handlePatientClick(item)">{{ item.patient_name
                                            }}</a>
                                      
                                      </h2>
                                    </td>
                                    <td>{{ item.city ? item.city : "-" }}</td>

                                    <td>
                                      {{ convertDate(item.encounter_date) }}
                                      <!-- <span class="d-block text-info">{{
                                        convertTime(item.appointment_datetime)
                                      }}
                                      </span> -->
                                    </td>
                                    <td>
                                      {{ item.encounter_time ? item.encounter_time.split(':').slice(0, 2).join(':') :
                                      '-' }}
                                    </td>

                                    <td class="text-left">
                                      <div class="table-action">
                                        <a href="javascript:void(0);" @click="downloadPDF(item.name)"
                                          class="btn btn-sm bg-info-light">
                                          <i class="fas fa-file-pdf"></i> Download PDF
                                        </a>

                                        <a v-if="item.request_access === 1" href="#" class="btn btn-sm bg-primary-light" data-toggle="modal"
                                          data-target="#appt_details">
                                            <i class="fas fa-universal-access"></i> Request Access
                                        </a>
                                      </div>
                                    </td>
                                    

                                  </tr>
                                </tbody>
                              </table>
                              <h5 v-if="closed_appointments.length === 0 &&
                                !showspinner
                              " class="No_data">
                                No Patient Encounters Found
                              </h5>
                            </div>
                            <!-- pagination start -->

                            <div id="pagination" v-if="closed_appointments.length > 10">
                              <ul class="pagination justify-content-center">

                                <!-- "Previous" Button -->
                                <li class="page-item" :class="closed_current === 1 ? 'disabled' : ''">
                                  <a href="#" class="page-link" aria-label="Previous"
                                    @click.prevent="updateClosedCurrent(closed_current - 1)">
                                    Previous
                                  </a>
                                </li>
                                <!-- Pagination Links (Display 5 at a time) -->
                                <li v-for="page_index in closed_paginate_total" :key="page_index.id" :class="[
                                  'page-item',
                                  closed_current === page_index ? 'active' : ''
                                ]" v-if="page_index >= closed_current - 2 && page_index <= closed_current + 2">
                                  <a href="#" class="page-link" @click.prevent="updateClosedCurrent(page_index)">
                                    {{ page_index }}
                                  </a>
                                </li>
                                <!-- "Next" Button -->
                                <li class="page-item" :class="closed_current === closed_paginate_total ? 'disabled' : ''
                                  ">
                                  <a href="#" class="page-link" aria-label="Next"
                                    @click.prevent="updateClosedCurrent(closed_current + 1)">
                                    Next
                                  </a>
                                </li>
                              </ul>
                            </div>

                            <!-- pagination end -->
                          </div>
                        </div>
                      </div>
                      <!-- /Closed Appointment Tab -->
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- /Page Content -->
      <layout-footer></layout-footer>
    </div>
  </div>
</template>

<script>
// import upcomingpatients from "../../assets/json/doctor/upcomingpatients.json";
// import todaypatients from "../../assets/json/doctor/todaypatients.json";
import CommonApi from "@/services/CommonApi";
import config from "../../../services/CommonApi";
import { mapState } from "vuex";
const images = require.context("@/assets/img/patients");

export default {
  data() {
    return {
      // upcomingpatients: upcomingpatients,
      // todaypatients: todaypatients,

      count_open: [],
      todays_date: new Date()
        .toString()
        .split(" ")
        .splice(1, 3)
        .join(" "),
      count_closed: [],
      config: config,
      total_appointment: "",
      todays_appointment: "",
      appointments: "",
      open_appointments: [],
      closed_appointments: [],
      showspinner: true,

      open_current: 1,
      open_paginate: 10,
      open_paginate_total: 0,

      closed_current: 1,
      closed_paginate: 10,
      closed_paginate_total: 0,
    };
  },
  mounted() {
    let user = localStorage.getItem("userInfo");
    if (!user) {
      this.$router.push({ name: 'login' })
    }
    this.User();
    this.get_doctor_patient_encounter_list_open(),
      this.get_doctor_patient_encounter_list_close();
    this.get_patient_encounter_count_open();
    this.get_patient_encounter_count_closed();

    $(".progressresult").each(function () {
      const percentageToDegrees = (percentage) => {
        return (percentage / 100) * 360;
      };
      let value = $(this).attr("data-value");
      let left = $(this).find(".progress-left .progress-bar");
      let right = $(this).find(".progress-right .progress-bar");

      if (value > 0) {
        if (value <= 50) {
          right.css(
            "transform",
            "rotate(" + percentageToDegrees(value) + "deg)"
          );
        } else {
          right.css("transform", "rotate(180deg)");
          left.css(
            "transform",
            "rotate(" + percentageToDegrees(value - 50) + "deg)"
          );
        }
      }
    });
  },
  computed: {
    ...mapState({
      user_id: (state) => state.user.user_id,
      user_type: (state) => state.user.user_type,

      open_paginate_total() {
        return Math.min(Math.ceil(this.open_appointments.length / this.open_paginate), 2); // Limit to 2 pages
      },
      closed_paginate_total() {
        return Math.min(Math.ceil(this.closed_appointments.length / this.closed_paginate), 2); // Limit to 2 pages
      },

      currentDay() {
        const daysOfWeek = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
        const today = new Date().getDay(); // Get the current day of the week (0-6)

        return daysOfWeek[today];
      },

    }),
  },
  methods: {


    handlePatientClick(item) {
    if (item.request_access === 1) {
      this.$router.push({
        name: 'update-patient-encounter-update',
        params: {
          patient_id: item.patient,
          appointment_id: item.appointment,
          encounter_id: item.name,
        },
      });
    } else {
      // Optionally, you could show a message or prevent further actions
      console.log('Access denied: Request access is not granted.');
    }
  },

    /* Get patient Open counts */
    get_patient_encounter_count_open() {
      let data = {
        practitioner: this.user_id,
      };
      CommonApi.post_data(
        "sahaj.api.get_patient_encounter_count_open",
        data
      ).then((res) => {
        this.showspinner = false;
        if (res.status_code == 200) {
          this.count_open = res.data;
        }
      });
    },

    /* Get patient Closed counts */
    get_patient_encounter_count_closed() {
      let data = {
        practitioner: this.user_id,
      };
      CommonApi.post_data(
        "sahaj.api.get_patient_encounter_count_closed",
        data
      ).then((res) => {
        this.showspinner = false;
        if (res.status_code == 200) {
          this.count_closed = res.data;
        }
      });
    },


    setOpenPaginate(i) {
      if (this.open_current == 1) {
        return i < this.open_paginate;
      } else {
        return (
          i >= this.open_paginate * (this.open_current - 1) &&
          i < this.open_current * this.open_paginate
        );
      }
    },

    updateOpenCurrent(i) {
      this.open_current = i;
      document.getElementById("patient_container").scrollIntoView();
    },

    setClosedPaginate(i) {
      if (this.closed_current == 1) {
        return i < this.closed_paginate;
      } else {
        return (
          i >= this.closed_paginate * (this.closed_current - 1) &&
          i < this.closed_current * this.closed_paginate
        );
      }
    },

    updateClosedCurrent(i) {
      this.closed_current = i;
      document.getElementById("encounter_container").scrollIntoView();
    },

    User() {
      if (this.user_type !== "doctor") {
        this.$router.push("/patient/index");
      }
    },

    loadImg(imgPath) {
      return images("./" + imgPath);
    },

    ClosedAppointment() {
      this.$store.dispatch("user/closedAppointment", false);
    },

    OpenAppointment() {
      this.$store.dispatch("user/closedAppointment", true);
    },

    /* Get Open Patient Encounter List */
    downloadPDF(id) {
      let data = {
        encounter_id: id,
      };
      CommonApi.post_data("sahaj.api.generate_encounter_pdf", data).then((res) => {
        const binaryData = atob(res.data);
        const arrayBuffer = new Uint8Array(binaryData.length);
        for (let i = 0; i < binaryData.length; i++) {
          arrayBuffer[i] = binaryData.charCodeAt(i);
        }
        const blob = new Blob([arrayBuffer], { type: 'application/pdf' });
        const url = URL.createObjectURL(blob);
        window.open(url);
      });
    },


    /* Get Open Patient Encounter List */
    get_doctor_patient_encounter_list_open() {
      let data = {
        practitioner: this.user_id,
      };
      CommonApi.post_data(
        "sahaj.api.get_doctor_patient_encounter_list_open",
        data
      ).then((res) => {
        this.showspinner = false;
        if (res.status_code == 200) {
          this.open_appointments = res.data;
          this.open_paginate_total = Math.ceil(
            this.open_appointments.length / this.open_paginate
          );
        }
      });
    },

    /* Get Closed Patient Encounter List  */
    get_doctor_patient_encounter_list_close() {
      let data = {
        practitioner: this.user_id,
      };
      CommonApi.post_data(
        "sahaj.api.get_doctor_patient_encounter_list",
        data
      ).then((res) => {
        this.showspinner = false;
        if (res.status_code == 200) {
          this.closed_appointments = res.data;
          this.closed_paginate_total = Math.ceil(
            this.closed_appointments.length / this.closed_paginate
          );
        }
      });
    },

    /* Get Date */
    // convertDate(str) {
    //   if (str === null || str === "") {
    //     return "";
    //   } else {
    //     var date = new Date(str),
    //       mnth = ("0" + (date.getMonth() + 1)).slice(-2),
    //       day = ("0" + date.getDate()).slice(-2);
    //     return [day, mnth, date.getFullYear()].join("-");
    //   }
    // },
    convertDate(str) {
      if (str === null || str === "") {
        return "";
      } else {
        var date = new Date(str),
          mnth = ("0" + (date.getMonth() + 1)).slice(-2),
          day = ("0" + date.getDate()).slice(-2),
          year = date.getFullYear().toString().slice(-2); // Get last two digits of the year
        return [day, mnth, year].join("-");
      }
    },
    convertTime(str) {
      if (str === null || str === "") {
        return "";
      } else {
        var date = new Date(str),
          time =
            ("00" + date.getHours()).slice(-2) +
            ":" +
            ("00" + date.getMinutes()).slice(-2) +
            ":" +
            ("00" + date.getSeconds()).slice(-2);
        var H = +time.substr(0, 2);
        var h = H % 12 || 12;
        var ampm = H < 12 ? " AM" : " PM";
        var timeString = h + time.substr(2, 3) + ampm;
        return timeString;
      }
    },
  },
};
</script>

<style scoped>
.active {
  background-color: #66CDAA !important;
  color: #fff !important;
}

.rounded-bracket {
  font-size: 14px;
  display: inline-flex;
  align-items: center;
  border: 1px solid #D3D3D3;
  border-radius: 50%;
  padding: 5px 10px;
  margin: 0 5px;
}

table {
  border-collapse: collapse;
  width: 100%;
  border-top: 1px solid #dddddd;
  /* Add an upper border */
}

th,
td {
  border: 1px solid #dddddd;
  /* You can adjust the border width and color as needed */
  padding: 8px;
  text-align: left;
}

th {
  background-color: #F8F8F8;
}
</style>


// WEBPACK FOOTER //
// src/components/kneexpert/doctor/PatientEncounter.vue